const positions = [
    {
        id: 'Head',
        left: '50%',
        top: '20px'
    },
    {
        id: 'Thorax',
        left: '50%',
        top: '100px'
    },
    {
        id: 'Right Arm',
        left: 'calc(50% - 200px)',
        top: '100px'
    },
    {
        id: 'Left Arm',
        left: 'calc(50% + 200px)',
        top: '100px'
    },
    {
        id: 'Stomach',
        left: '50%',
        top: '180px'
    },
    {
        id: 'Right Leg',
        left: 'calc(50% - 150px)',
        top: '280px'
    },
    {
        id: 'Left Leg',
        left: 'calc(50% + 150px)',
        top: '280px'
    }
];

export default positions;